<script lang="ts" context="module">
	import { page } from "$app/stores";
	import NotificationBar from "./notification-bars/NotificationBar.svelte";
</script>

<script lang="ts">
	const isLoggedIn = !!$page.data.loggedInUser;

	let toolbarContainer: HTMLDivElement;
	let toolbarContentHeight: number;

	$: if (toolbarContainer) {
		calculateToolbarHeight();
		// There is an issue with the material icons, that causes a gap between the toolbar and the rest of the content.
		// This is caused by the way we calculate the height and set it to the css variable,
		// since it takes time to download the material-icons font and use it by the browser (looks like it shows the text instead of the icon).
		// Therefore we introduce this workaround that fixes that and we still have a slight jump in the UI
		// but we don't have the gap anymore.
		setTimeout(calculateToolbarHeight, 400);
	}

	function calculateToolbarHeight() {
		// Warning: Use "getBoundingClientRect().height" instead of the "offsetHeight" property as
		// 					the latter returns a rounded integer instead of an accurate float.
		toolbarContentHeight = toolbarContainer.getBoundingClientRect().height;
		document.body.style.setProperty("--full-toolbar-height", toolbarContentHeight + "px");
	}

	// .tb-container class is a marker class, used by the Modal component to draw the modal overlay above the toolbar
	// Do not remove or change it, without making sure that the Modal.svelte works as expected in all places
	// (specially in management dashboard, remove member)
</script>

<div
	bind:this={toolbarContainer}
	class="tb-container fixed top-0 z-50 mx-auto w-full bg-white text-nxgray-600 shadow-[0_2px_2px_rgba(0,0,0,0.1)]">
	{#if isLoggedIn}
		<NotificationBar />
	{/if}

	<div class="container-1200 tb-content relative flex h-[60px] items-center justify-between">
		<div class="toolbar tb-group-left flex h-[60px] items-center sm:gap-0.5 md:gap-1 lg:gap-1.5 xl:gap-2">
			<slot name="left-side" />
		</div>
		<div class="tb-group-right flex h-[60px] items-center text-14 sm:gap-0.5 md:gap-1 lg:gap-1.5 xl:gap-2">
			<slot name="right-side" />
		</div>
	</div>
</div>

<div style="height: var(--full-toolbar-height, 60px);"></div>
